export const environment = {
  production: false,
  iosReviewInprogress: true,
  featureFlagsPath: 'assets/featureFlagsDetails.json',
  appName: 'Bazaarnear',
  // appName: 'Partson',
  // appName: 'Digikari',

  // WITHOUT AUTHENTICATION
  bazaarnearUrl: "https://tobeonline.in/ecomapiwithauth/api", /***Production URL***/
  // bazaarnearUrl: "https://qiit.in/ecomapiwithauth/api",  /***Staging URL***/
  partsonUrl: "https://bazaarnear.com/ecomapiwithauth/api",
  easyvetUrl: 'https://easyvet.live/ecomapi',
  offersURL: 'https://fintelligence.live/offerapis/api',

  // with authentication
  bazaarnearUrlAuth: "https://tobeonline.in/authapi/gateway/ecom",  /***Production URL***/
  // bazaarnearUrlAuth: "https://qiit.in/authapi/gateway/ecom", /***Staging URL***/
  partsonUrlAuth: "https://bazaarnear.com/authapi/gateway/ecom",
  easyvetUrlAuth: 'https://easyvet.live/ecomapi',

  // AUTH login API
  bazaarnearUrlLogin: "https://tobeonline.in/authapi/api", /***Production URL***/
  // bazaarnearUrlLogin: "https://qiit.in/authapi/api", /***Staging URL***/
  partsonUrlLogin: "https://bazaarnear.com/authapi/api",
  easyvetUrlLogin: 'https://easyvet.live/ecomapi',

    // subscription API
  subscriptionApiBaseUrl: "https://tobeonline.in/authapi/gateway/subscriptionapi", /***Production URL***/
  // subscriptionApiBaseUrl: "https://qiit.in/authapi/gateway/subscriptionapi", /***Staging URL***/

  firebaseConfig: { apiKey: "AIzaSyD8DLmnRBuJ562JboxypZzZdzzaloAHpKo", authDomain: "q5ecom.firebaseapp.com", projectId: "q5ecom", storageBucket: "q5ecom.appspot.com", messagingSenderId: "1077936017920", appId: "1:1077936017920:web:cdec2571e07a192c73fee5", measurementId: "G-V6KPZ28F2B" },

  deilveryPartner: "delhivery",

  //DESKTOP APP NAVIGATION URLS
  desktopBazaarnear: 'https://admin.tobeonline.in/', /***Production URL***/
  // desktopBazaarnear: 'https://admin.qiit.in/', /***Staging URL***/
  desktopDigikari: 'https://digikari.com/admin/',
  desktopPartson: 'https://partson.in/admin/',

  browserType: 'Mobile',
  appId: 2,
  appVersion: 1,
  //Version moved to app config file

  //THIRD PARTY URL VARIABLES
  thirdPartyUserKey: 'thirdpartyuserkey',
  thirdPartyAppURL: 'https:%2F%2Fservicenear.in',


  //GOOGLE AUTH VARIABLES
  CLIENT_ID: '1077936017920-e1c6gf2klt434cjti1e6em1mquis22du.apps.googleusercontent.com',
};



